import React from 'react';
import './css/custom.css';
import $ from 'jquery';
import Header from './include/Header';
import Dashboard from './include/Dashboard';
import Footer from './include/Footer';
import withAuthorization from './session/withAuthorization';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Driver from './include/Driver';
import Users from './include/Users';
import Maps from './include/Maps';
import Vehicle from './include/Vehicle';
import { MyProvider } from './context';
import Trips from './include/Trips';
import WithdrawRequest from './include/WithdrawRequest';
const authCondition = (authUser) => !!authUser;
class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: ""
    }
  }
  componentDidMount() {
    if (window.location.pathname == '/login') {
      window.location.href = ("/");
    }
    $("body").addClass("m-page--wide m-header--fixed m-header--fixed-mobile m-footer--push m-aside--offcanvas-default m-header--minimize-off");
    // $("body").addClass("m-page--wide m-header--fixed m-header--fixed-mobile m-footer--push m-aside--offcanvas-default m-header--minimize-on m-scroll-top--shown");
    $("body").removeClass('login');
    let _this = this;
    $(document).ready(function (event) {
      $("#m_quicksearch_input").keyup(function (e) {
        _this.setState({
          search: $(this).val()
        })
      });
      _this.setState({
        search: $("#m_quicksearch_input").val()
      })
    });
  }
  render() {
    return (
      <MyProvider>
        <Router>
          <div className="m-grid m-grid--hor m-grid--root m-page">
            <Header />
            <Route exact path="/" component={Dashboard} />
            <Route exact path="/withdraw" component={WithdrawRequest} />
            <Route path="/drivers" component={() => <Driver search={this.state.search} />} />
            <Route path="/users" component={() => <Users search={this.state.search} />} />
            <Route path="/trips" component={() => <Trips search={this.state.search} />} />
            <Route exact path="/vehicles" component={() => <Vehicle search={this.state.search} />} />
            <Route path="/vehicles/:edit" component={() => <Vehicle search={this.state.search} />} />
            <Route path="/maps" component={Maps} />
            <Footer />
          </div>
        </Router>
      </MyProvider>
    );
  }
}

export default withAuthorization(authCondition)(Home);



// WEBPACK FOOTER //
// ./src/Home.js